/**
 * Object identifier module
 *
 * This module biuld or retrieve object identifier
 *
 * Ex: My/type(123)
 *
 */

'use strict';

const _ = require('lodash');

/**
 * Retrieve type and id
 *
 * @param  {string} objectIdentity [description]
 * @returns {object} identifier
 */
module.exports.getObject = function(objectIdentity) {
    if (!_.isString(objectIdentity)) {
        throw new Error('Object identity not found in ObjectIdentifier::getObject');
    }

    let res = /(.+)\(([a-f0-9]+)\)$/.exec(objectIdentity);

    return (null !== res) ? {'type': res[1], 'uid': res[2]} : res;
};

/**
 * Build object identifier
 *
 * @param  {string} type [description]
 * @param  {Integer | string} uid
 * @returns {string} identifier
 */
module.exports.build = function(type, uid) {
    if (!_.isString(type) || !uid) {
        throw new Error('type or id missing on ObjectIdentifier::build');
    }

    return type + '(' + uid + ')';
};
